export const MUTATIONS = {
    SET_USE_CASES: 'setUseCases',
    SET_USER_PROFILE: 'setUserProfile',
}

export const ACTIONS = {
    LOAD_USE_CASES: 'loadUseCases',
    SET_USER_PROFILE_DATA: 'setUserProfileData',
}
